define('Hack.Common', [
    'Header.Logo.View',
    'Transaction.Line.Views.Option.View',

    'Backbone',
    'Backbone.View.render'
],
function HackCommon(
    HeaderLogoView,
    TransactionLineViewsOptionView,

    Backbone
) {
    'use strict';

    HeaderLogoView.addExtraContextProperty = Backbone.View.addExtraContextProperty;
    TransactionLineViewsOptionView.addExtraContextProperty = Backbone.View.addExtraContextProperty;
});

